<ng-container *ngIf="state$ | async as state">
  <div *ngIf="state.data && state.contactData?.contactData && state.isVisible"
       data-cy="contact-box-navigation"
  >
    <div class="row spacer-bottom">
      <div class="col-md-4">
        <p>
          <mb-contact-box-line [text]="state.contactData.contactData.company"
                               bold
                               noLabel
                               tag="company"
          ></mb-contact-box-line>
          <mb-contact-box-line [text]="state.contactData.contactData.street"
                               noLabel
                               tag="street"
          ></mb-contact-box-line>
          <mb-contact-box-line [text]="state.contactData.contactData.cityAndZip"
                               noLabel
                               tag="city-and-zip"
          ></mb-contact-box-line>
        </p>
      </div>
      <div class="col-md-8">
        <p>
          <mb-contact-box-line [text]="state.contactData.contactData.phone"
                               tag="phone"
          ></mb-contact-box-line>
          <mb-contact-box-line [text]="state.contactData.contactData.fax"
                               tag="fax"
          ></mb-contact-box-line>
          <mb-contact-box-line [text]="state.contactData.contactData.email"
                               [cmsLinkType]="cmsLinkType.EMAIL_LINK"
                               inputType="mail"
                               tag="email"
          ></mb-contact-box-line>
          <mb-contact-box-line [text]="state.contactData.contactData.web"
                               [cmsLinkType]="cmsLinkType.CONTENT_LINK"
                               inputType="link"
                               tag="web"
          ></mb-contact-box-line>
        </p>
      </div>
    </div>

    <div class="row spacer-bottom">
      <div class="col-md-4">
        <p data-cy="contact-box-navigation-title-orders">
          <strong>{{ 'shared.contactBoxFullOrdersTitle' | cxTranslate }}:</strong>
        </p>
      </div>
      <div class="col-md-8">
        <p>
          <mb-contact-box-line [text]="state.contactData.contactData.ordersPhone"
                               tag="ordersPhone"
          ></mb-contact-box-line>
          <mb-contact-box-line [text]="state.contactData.contactData.ordersFax"
                               tag="ordersFax"
          ></mb-contact-box-line>
          <mb-contact-box-line [text]="state.contactData.contactData.ordersEmail"
                               [cmsLinkType]="cmsLinkType.EMAIL_LINK"
                               inputType="mail"
                               tag="ordersEmail"
          ></mb-contact-box-line>
        </p>
      </div>
    </div>

    <div class="row spacer-bottom">
      <div class="col-md-4">
        <p data-cy="contact-box-navigation-title-technical">
          <strong>{{ 'shared.contactBoxFullTechnicalTitle' | cxTranslate }}:</strong>
        </p>
      </div>
      <div class="col-md-8">
        <p>
          <mb-contact-box-line [text]="state.contactData.contactData.technicalPhone"
                               tag="technicalPhone"
          ></mb-contact-box-line>
          <mb-contact-box-line [text]="state.contactData.contactData.technicalSupportPhoneAvailability"
                               tag="technicalSupportPhoneAvailability"
          ></mb-contact-box-line>
          <mb-contact-box-line [text]="state.contactData.contactData.technicalSupportEmail"
                               [cmsLinkType]="cmsLinkType.EMAIL_LINK"
                               inputType="mail"
                               tag="technicalSupportEmail"
          ></mb-contact-box-line>
        </p>
        <p>
          <span *ngIf="state.contactData.linkTechnicalSupport.text.trim().length"
                data-cy="contact-box-navigation-technical-text"
          >
            {{ 'shared.technicalSupportText' | cxTranslate }}
            <mb-link [linkData]="state.contactData.linkTechnicalSupport"
                     (click)="closeContact.emit($event)"
                     dataCy="contact-box-navigation-technical-link"
            ></mb-link>
          </span>
        </p>
      </div>
    </div>

    <div *ngIf="state.contactData.linkDistribution.text.trim().length"
         class="row spacer-bottom"
    >
      <div class="col-md-4">
        <p data-cy="contact-box-navigation-title-distribution">
          <strong>{{ 'shared.localDistribution' | cxTranslate }}:</strong>
        </p>
      </div>
      <div class="col-md-8">
        <p>
          <span data-cy="contact-box-navigation-distribution-text"
          >
            {{ 'shared.localDistributionText' | cxTranslate }}
            <mb-link [linkData]="state.contactData.linkDistribution"
                     (click)="closeContact.emit($event)"
                     dataCy="contact-box-navigation-distribution-link"
            ></mb-link>
          </span>
        </p>
      </div>
    </div>
  </div>
</ng-container>
